import './ORGANIZATION_AUE_PIECHART_WidgetLayout.css';

import AUE_Impact from '../../../../b2b-frameworks/components/framework-impact/aue/AUE_Impact';
import { Avatar, Box } from '@mui/material';
import useFwImagePath from '../../../../b2b-frameworks/hooks/useFwImagePath';
import { fullImagePath } from '../../../../b2b-common/helpers';

const ORGANIZATION_AUE_PIECHART_WidgetLayout = ({ data, size = 420, locale }) => {
    const imagePath = useFwImagePath('generic', 1);
    return (
        <Box className={`ORGANIZATION_AUE_PIECHART_Widget-container`}
            display='flex' flexDirection='column' justifyContent='center' alignItems='center'
            boxSizing={'border-box'} width='100%' height={'100%'} position={'relative'}
        >
            <AUE_Impact
                data={data}
                size={size}
                locale={locale}
                onClick={(index) => {
                    // Handle click event here
                    console.log('Clicked on index:', index);
                }}
                className={'OrgAUEPieWidget'}
            />
            {imagePath && (
                <Avatar
                    variant='circular'
                    src={fullImagePath(imagePath)}
                    alt={`FwImage`}
                    sx={{
                        width: '20px',
                        height: '20px',
                        position: 'absolute',
                        top: '0px',
                        right: '0px',
                    }}
                />
            )}
        </Box>
    );
}

export default ORGANIZATION_AUE_PIECHART_WidgetLayout;
